import { Keys } from '../types';

const keys: Keys = {
  infura: 'dc513f59a9df4edca4329dc46c8295b6',
};

export default keys;
